import React from 'react';
import { useNavigate } from 'react-router-dom';
import SearchWidget from './SearchWidget';

function CustomerView() {
  const navigate = useNavigate();

  const handleSearchStart = ({ queryPhrase, channelUrl, customerKey }) => {
    console.log('Search started:', { queryPhrase, channelUrl, customerKey });
  };

  const handleSearchEnd = ({ results, error, queryPhrase, channelUrl, customerKey }) => {
    if (error) {
      console.error('Search error:', error);
    } else {
      console.log('Search completed:', { queryPhrase, channelUrl, resultsCount: results.length });

      if (queryPhrase && channelUrl && results) {
        const queryKey = `queryResults_${channelUrl}_${queryPhrase}`;
        localStorage.setItem(queryKey, JSON.stringify(results));
        localStorage.setItem('lastQueryKey', queryKey);

        if (customerKey) {
          localStorage.setItem('lastCustomerKey', customerKey);
        }
      }
    }
  };

  const handleResultClick = ({ result, videoGroup, actionProps }) => {
    console.log('Result clicked:', { result, videoGroup, actionProps });
  };

  return (
    <div style={{
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      maxWidth: '780px',
      margin: '0 auto',
      padding: '48px 20px 80px',
      color: '#1a1a1a',
      minHeight: '100vh',
      background: '#fff',
    }}>
      <header style={{ textAlign: 'center', marginBottom: '48px' }}>
        <img
          src="/inquiros-logo.png"
          alt="Inquiros"
          style={{ height: '48px', display: 'block', margin: '0 auto' }}
        />
        <p style={{
          fontSize: '0.95rem',
          color: '#888',
          marginTop: '6px',
          fontWeight: 400,
        }}>
          AI-powered in-video search
        </p>
      </header>

      <SearchWidget
        showDemoSelector={true}
        theme="light"
        onSearchStart={handleSearchStart}
        onSearchEnd={handleSearchEnd}
        onResultClick={handleResultClick}
        style={{ background: 'transparent', padding: 0 }}
      />

      <footer style={{
        textAlign: 'center',
        marginTop: '48px',
        paddingTop: '16px',
        borderTop: '1px solid #f0f0f0',
      }}>
        <button
          onClick={() => navigate('/admin')}
          style={{
            background: 'none',
            border: 'none',
            color: '#bbb',
            fontSize: '0.8rem',
            cursor: 'pointer',
            padding: '4px 8px',
          }}
        >
          Admin
        </button>
      </footer>
    </div>
  );
}

export default CustomerView;
